export default function F1SubCategory() {
  return (
    <>
      <>F1 sub category</>
    </>
  );
}
